import React, { useState, useEffect } from 'react';
import { UserProvider } from './context/UserContext';
import Navigation from './components/Navigation';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import Dashboard from './pages/Dashboard';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('login');
  const [user, setUser] = useState(null);

  // Check for existing session - use same token key as backendAPI
  useEffect(() => {
    const token = localStorage.getItem('sportiq_token'); // ✅ Match backendAPI token key
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
      setCurrentPage('dashboard');
    }
  }, []);

  const handleLogin = (userData, token) => {
    setUser(userData);
    localStorage.setItem('sportiq_token', token); // ✅ Match backendAPI token key
    localStorage.setItem('user', JSON.stringify(userData));
    setCurrentPage('dashboard');
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('sportiq_token'); // ✅ Match backendAPI token key
    localStorage.removeItem('user');
    setCurrentPage('login');
  };

  return (
    <UserProvider>
      <div className="App">
        {user && <Navigation currentPage={currentPage} setCurrentPage={setCurrentPage} onLogout={handleLogout} />}
        
        {currentPage === 'login' && (
          <LoginPage onLogin={handleLogin} onSwitchToSignup={() => setCurrentPage('signup')} />
        )}
        
        {currentPage === 'signup' && (
          <SignUpPage onSignup={handleLogin} onSwitchToLogin={() => setCurrentPage('login')} />
        )}
        
        {currentPage === 'dashboard' && user && (
          <Dashboard user={user} />
        )}
      </div>
    </UserProvider>
  );
}

export default App;
